import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import StyledButton from "components/shared/StyledButton";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { createTitleFormatType, updateTitleFormatType } from "store/titleFormatTypeStore";
import type { ITitleFormatType } from "store/titleFormatTypeStore";
import { useAppDispatch } from "store/store";

import styles from "./style.module.scss";

type FormatTypeFormValues = {
    name: string;
};

type FormatTypeFormProps = {
    formatType?: ITitleFormatType;
    onClose: () => void;
    onRequestDelete?: () => void;
};

const FormatTypeForm = ({ formatType, onClose, onRequestDelete }: FormatTypeFormProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const isEdit = formatType != null;

    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm<FormatTypeFormValues>({
        defaultValues: { name: formatType?.name ?? "" },
    });

    const onSubmit = async ({ name }: FormatTypeFormValues) => {
        const trimmed = name.trim();
        if (!trimmed) return;

        const response = isEdit
            ? await dispatch(updateTitleFormatType({ id: formatType.id, name: trimmed }))
            : await dispatch(createTitleFormatType({ name: trimmed }));

        if (response.meta.requestStatus === "fulfilled") {
            onClose();
        }
    };

    return (
        <form className={styles["format-type-form"]} onSubmit={handleSubmit(onSubmit)}>
            <TextFormComponent
                label={t("Settings.FormatTypeName")}
                placeholder={t("Settings.FormatTypePlaceholder")}
                control={control}
                controlName="name"
                required
                fullWidth
                error={errors.name}
            />
            <div className={styles["format-type-form-actions"]}>
                {isEdit && onRequestDelete ? (
                    <StyledButton buttonType="danger" type="button" onClick={onRequestDelete} fullWidth>
                        {t("Settings.DeleteFormatType")}
                    </StyledButton>
                ) : (
                    <StyledButton buttonType="secondary" type="button" onClick={onClose} fullWidth>
                        {t("Settings.FormatTypeCancel")}
                    </StyledButton>
                )}
                <StyledButton buttonType="primary" type="submit" loading={isSubmitting} fullWidth>
                    {t("Settings.SaveFormatType")}
                </StyledButton>
            </div>
        </form>
    );
};

export default FormatTypeForm;
